import { Declaration } from 'store/declarations/declaration';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import MirroredLinksButton from 'views/declarations/mirroring/mirrored-links-button/MirroredLinksButton';
import { SpanEllipsis } from '../DeclarationsTable.styled';
import { getDeclarationType } from '../../DeclarationColumns';

type Props = {
    record?: Declaration & {
        parentDeclarationId?: string;
    };
    dataTestId?: string;
};

const DeclarationType = ({ record, dataTestId }: Props) => {
    if (!record) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }} data-testid={dataTestId}>
            <SpanEllipsis>{getDeclarationType(record)}</SpanEllipsis>
            <MirroredLinksButton declaration={record} />
        </div>
    );
};

export default DeclarationType;
